export const FETCHING = "USER_AUTH/FETCHING";
export const SUCCESS = "USER_AUTH/SUCCESS";
export const ERROR = "USER_AUTH/ERROR";
export const USER_INFO = "USER_AUTH/USER_INFO"
export const FORGOT_PASSSWORD_LINK = "FORGOT_PASSWORD_LINK";